import Vue from 'vue'

import { Api } from '@/common/api'
import Cache from '@/common/cache'

function _addOption(el, text, value) {
    var option = document.createElement("option");
    option.text = text;
    option.value = value;
    el.add(option);
}

function _addItems(el, items) {
    for (var i = 0; i < items.length; i++) {
        _addOption(el, items[i].name, items[i].id);
    }
}

Vue.directive('select', {
    twoWay: true,
    bind: function (el, binding) {

        if (binding.value.default)
            _addOption(el, binding.value.default, "");

        var resource = binding.value.dataitem + "/dataitems";

        var filters = {};
        if (binding.value.filters)
            filters = binding.value.filters;

        var cachekey = "combobox_" + binding.value.dataitem + "_" + JSON.stringify(filters);

        var fromcache = Cache.get(cachekey);
        if (fromcache && !binding.value.notcache) {
            var items = JSON.parse(fromcache);
            _addItems(el, items);
            return;
        }

        var api = new Api(resource);
        api.dataItem(filters).then(data => {
            if (data.dataList) {
                Cache.add(cachekey, JSON.stringify(data.dataList));
                _addItems(el, data.dataList);
            }
        });
    }
})